import React, { useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';

import { useUiContext } from '../../../../../../context/UiContext';
import BillPaymentService from '../../../../../../services/BillPaymentService';

const createDialogModalReverseBillPaymentText = (billPayment) => {
  let message = 'Are you sure you want to reverse this payment?';

  if (billPayment.billcom_sentpay_id) {
    message =
      'Are you sure you want to reverse this payment? The payment has already been scheduled with Bill.com. This action will not cancel the bill payment, but will allow the bill payment to be re-applied to different bills.';
  }

  return message;
};

export default function ReversBillPaymentButton({
  billPayment,
  refetch,
  setIsBillPaymentBeingReversed,
}) {
  const { showDialogModal, showToast } = useUiContext();

  const { mutate: reverseBillPayment, isPending } = useMutation({
    // eslint-disable-next-line no-shadow
    mutationFn: () => BillPaymentService.reverseBillPayment(billPayment.id),
    onSuccess: async () => {
      showToast({
        text: 'Bill Payment reversed successfully',
        type: 'success',
      });

      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  useEffect(() => {
    if (isPending) {
      setIsBillPaymentBeingReversed(true);
    } else {
      setIsBillPaymentBeingReversed(false);
    }
  }, [isPending, setIsBillPaymentBeingReversed]);

  if (!billPayment) {
    return null;
  }

  if (
    !(
      !!billPayment._bills?.length &&
      billPayment.status !== 'void' &&
      (!billPayment.billom_sentpay_id ||
        (!!billPayment.billcom_sentpay_id &&
          billPayment.billcom_sentpay_status === 'Void'))
    )
  ) {
    return null;
  }

  return (
    <button
      onClick={() => {
        showDialogModal({
          title: 'Confirmation',
          type: 'danger',
          message: createDialogModalReverseBillPaymentText(billPayment),
          onConfirm: () => reverseBillPayment(),
          confirmButtonLabel: 'Yes, reverse the bill payment',
          cancelButtonLabel: 'No, cancel',
        });
      }}
      disabled={isPending}
      type="button"
      className="btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-rose-500"
    >
      Reverse Bill Payment
    </button>
  );
}
